module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00058.0e807dd1.jpg";